import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getCostComponents,
  getCostComponentById,
  createCostComponent,
  updateCostComponent,
  deleteCostComponent,
} from "libs/api/cost_component";

export const getCostComponentsThunk = createAsyncThunk(
  "costComponent/getCostComponents",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, queryParams }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await getCostComponents(queryParams);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const getCostComponentByIdThunk = createAsyncThunk(
  "costComponent/getCostComponentById",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, id }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await getCostComponentById(id);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const createCostComponentThunk = createAsyncThunk(
  "costComponent/createCostComponent",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, body }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await createCostComponent(body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const updateCostComponentThunk = createAsyncThunk(
  "costComponent/updateCostComponent",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, id, body }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await updateCostComponent(id, body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const deleteCostComponentThunk = createAsyncThunk(
  "costComponent/deleteCostComponent",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, id }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await deleteCostComponent(id);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);
